//  Add favourite items
export const ADD_ITEMS_TO_FAVOURITE_REQUEST = 'ADD_ITEMS_TO_FAVOURITE_REQUEST';
export const ADD_ITEMS_TO_FAVOURITE_SUCCESS = 'ADD_ITEMS_TO_FAVOURITE_SUCCESS';
export const ADD_ITEMS_TO_FAVOURITE_FAIL = 'ADD_ITEMS_TO_FAVOURITE_FAIL';

//  CREATING ITEM
export const CREATE_QUICKCHECKOUT_ITEM_REQUEST =
  'CREATE_QUICKCHECKOUT_ITEM_REQUEST';
export const CREATE_QUICKCHECKOUT_ITEM_SUCCESS =
  'CREATE_QUICKCHECKOUT_ITEM_SUCCESS';
export const CREATE_QUICKCHECKOUT_ITEM_FAIL = 'CREATE_QUICKCHECKOUT_ITEM_FAIL';

//  get favourite items
export const GET_FAVOURITE_ITEMS_REQUEST = 'GET_FAVOURITE_ITEMS_REQUEST';
export const GET_FAVOURITE_ITEMS_SUCCESS = 'GET_FAVOURITE_ITEMS_SUCCESS';
export const GET_FAVOURITE_ITEMS_FAIL = 'GET_FAVOURITE_ITEMS_FAIL';

//  ADDING TO INVENTORY
export const ADD_ITEMS_TO_INVENTORY_REQUEST = 'ADD_ITEMS_TO_INVENTORY_REQUEST';
export const ADD_ITEMS_TO_INVENTORY_SUCCESS = 'ADD_ITEMS_TO_INVENTORY_SUCCESS';
export const ADD_ITEMS_TO_INVENTORY_FAIL = 'ADD_ITEMS_TO_INVENTORY_FAIL';

// update/ delete favourites
export const UPDATE_DELETE_FAVOURITE_REQUEST =
  'UPDATE_DELETE_FAVOURITE_REQUEST';
export const UPDATE_DELETE_FAVOURITE_SUCCESS =
  'UPDATE_DELETE_FAVOURITE_SUCCESS';
export const UPDATE_DELETE_FAVOURITE_FAIL = 'UPDATE_DELETE_FAVOURITE_FAIL';

// updating favourite state (delete/incsert)
export const UPDATE_FAVOURITE_STATE = 'UPDATE_FAVOURITE_STATE';

//  Creating  Quick check out
export const CREATE_QUICK_CHECK_OUT_REQUEST = 'CREATE_QUICK_CHECK_OUT_REQUEST';
export const CREATE_QUICK_CHECK_OUT_SUCCESS = 'CREATE_QUICK_CHECK_OUT_SUCCESS';
export const CREATE_QUICK_CHECK_OUT_FAIL = 'CREATE_QUICK_CHECK_OUT_FAIL';

// Get checkout list
export const GET_CHECKOUT_LIST_REQUEST = 'GET_CHECKOUT_LIST_REQUEST';
export const GET_CHECKOUT_LIST_SUCCESS = 'GET_CHECKOUT_LIST_SUCCESS';
export const GET_CHECKOUT_LIST_FAIL = 'GET_CHECKOUT_LIST_FAIL';

// delete checkout
export const DELETE_CHECKOUT_REQUEST = 'DELETE_CHECKOUT_REQUEST';
export const DELETE_CHECKOUT_SUCCESS = 'DELETE_CHECKOUT_SUCCESS';
export const DELETE_CHECKOUT_FAIL = 'DELETE_CHECKOUT_FAIL';

// clearing deleted checkout state
export const CLEAR_DELETED_CHECKOUT_STATE = 'CLEAR_DELETED_CHECKOUT_STATE';

// update checkout list state on delete checkout
export const UPDATE_CHECKOUT_LIST_ON_DELETE = 'UPDATE_CHECKOUT_LIST_ON_DELETE';

export const CLEAR_CREATE_QUICK_CHECK_OUT_STATE =
  'CLEAR_CREATE_QUICK_CHECK_OUT_STATE';

// clearing Quick check out state

export const CLEAR_QUICK_CHECK_OUT_STATE = 'CLEAR_QUICK_CHECK_OUT_STATE';
